import { Icon } from "@iconify/react/dist/iconify.js";

const ResumenView = ({ resumen, onVolver }) => {
  if (!resumen) return null;

  const {
    mentor_nombre,
    estudiante_nombre,
    talento_nombre,
    talento_ranking,
    conversacion_numero,
    conversacion_pregunta,
    estado,
    fecha_inicio,
    fecha_completado,
    respuestas,
  } = resumen;

  return (
    <div className="resumen-view">
      <div className="d-flex align-items-center gap-2 mb-4">
        <button className="btn btn-sm btn-outline-secondary" onClick={onVolver}>
          <Icon icon="mdi:arrow-left" className="me-1" />
          Volver
        </button>
        <h5 className="mb-0">Resumen de la sesión</h5>
      </div>

      {/* Datos generales */}
      <div className="card p-24 radius-12 mb-4">
        <div className="row g-3">
          <div className="col-md-6">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Icon icon="mdi:forum" width="20" className="text-primary" />
              <span>
                Conversación #{conversacion_numero}: {conversacion_pregunta}
              </span>
            </div>
            <div className="d-flex align-items-center gap-2 mb-2">
              <Icon icon="mdi:star" width="20" className="text-warning" />
              <span>
                {talento_nombre}
                {talento_ranking && (
                  <span className="badge bg-warning-subtle text-warning ms-2">
                    Ranking #{talento_ranking}
                  </span>
                )}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Icon icon="mdi:account-tie" width="20" className="text-secondary" />
              <span>Mentor: <strong>{mentor_nombre}</strong></span>
            </div>
            <div className="d-flex align-items-center gap-2 mb-2">
              <Icon icon="mdi:account-school" width="20" className="text-secondary" />
              <span>Estudiante: <strong>{estudiante_nombre}</strong></span>
            </div>
            <div className="d-flex align-items-center gap-2 mb-2">
              <Icon icon="mdi:calendar" width="20" className="text-secondary" />
              <small className="text-muted">
                Inicio: {fecha_inicio}
                {fecha_completado && ` · Completado: ${fecha_completado}`}
              </small>
            </div>
            <span
              className={`badge ${estado === "completado" ? "bg-success" : "bg-warning"}`}
            >
              {estado === "completado" ? "Completado" : "En progreso"}
            </span>
          </div>
        </div>
      </div>

      {/* Respuestas por configuración */}
      {respuestas && respuestas.length > 0 ? (
        respuestas.map((grupo) => (
          <div
            key={grupo.configuracion_id}
            className="card radius-12 mb-3"
          >
            <div className="card-header bg-transparent">
              <div className="d-flex align-items-center gap-2">
                <span className="badge bg-primary-subtle text-primary">
                  {grupo.tipo_display}
                </span>
                <span className="fw-medium">{grupo.frase_guia}</span>
              </div>
            </div>
            <div className="card-body">
              {/* Respuestas del mentor */}
              {grupo.respuestas_mentor?.length > 0 && (
                <div className="mb-3">
                  <label className="fw-medium text-primary mb-2">
                    <Icon icon="mdi:account-tie" className="me-1" />
                    Mentor — {mentor_nombre}
                  </label>
                  {grupo.respuestas_mentor.map((r) => (
                    <div key={r.id} className="ms-3 mb-2">
                      {r.texto && (
                        <p className="mb-2 p-2 bg-primary-subtle bg-opacity-10 radius-8">
                          {r.texto}
                        </p>
                      )}
                      {r.archivos_multimedia?.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 ms-3">
                          {r.archivos_multimedia.map((m) => (
                            <a
                              key={m.id}
                              href={m.archivo_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-secondary"
                            >
                              <Icon icon="mdi:file" className="me-1" />
                              {m.nombre_original || m.tipo_archivo_display}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Respuestas del estudiante */}
              {grupo.respuestas_estudiante?.length > 0 && (
                <div>
                  <label className="fw-medium text-info mb-2">
                    <Icon icon="mdi:account-school" className="me-1" />
                    Estudiante — {estudiante_nombre}
                  </label>
                  {grupo.respuestas_estudiante.map((r) => (
                    <div key={r.id} className="ms-3 mb-2">
                      {r.texto && (
                        <p className="mb-2 p-2 bg-info-subtle bg-opacity-10 radius-8">
                          {r.texto}
                        </p>
                      )}
                      {r.archivos_multimedia?.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 ms-3">
                          {r.archivos_multimedia.map((m) => (
                            <a
                              key={m.id}
                              href={m.archivo_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-info"
                            >
                              <Icon icon="mdi:file" className="me-1" />
                              {m.nombre_original || m.tipo_archivo_display}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {(!grupo.respuestas_mentor?.length &&
                !grupo.respuestas_estudiante?.length) && (
                <p className="text-muted fst-italic mb-0">
                  Sin respuestas registradas.
                </p>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="card p-24 radius-12 text-center">
          <Icon
            icon="mdi:alert-circle-outline"
            width="40"
            className="text-muted mb-2"
          />
          <p className="text-secondary mb-0">
            No se encontraron respuestas para esta sesión.
          </p>
        </div>
      )}
    </div>
  );
};

export default ResumenView;
